import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider, Env } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { Newsletter as SignupNewsletter } from '@interfaces/homepage';
import { Page } from '@tracking';
import { User } from '@utils/backend-api/currentUser';
import { Newsletter } from '@utils/backend-api/newsletters';
import { LiveStream, TITVEvent } from '@utils/backend-api/titv';

import DailyShowDescription from './DailyShowDescription';
import EventStreamPlayer from './EventStreamPlayer';
import NewslettersSignup from './NewslettersSignUp';
import PastEvents from './PastEvents';
import { TITVPartnerAd } from './interfaces';

interface TITVProps {
  availableNewsletters?: Newsletter[];
  env: Env;
  isGdprRequired: boolean;
  initialCurrentUser?: User;
  inProgressStream?: LiveStream;
  isWebview: boolean;
  mostRecentStream?: TITVEvent;
  partnerAds?: TITVPartnerAd[];
  signupNewsletter?: SignupNewsletter;
}

const queryClient = new QueryClient();

const TITV = ({
  availableNewsletters,
  env,
  isGdprRequired,
  initialCurrentUser,
  inProgressStream,
  isWebview,
  mostRecentStream,
  partnerAds,
  signupNewsletter,
}: TITVProps) => {
  const { Track } = useEventTracking({
    page: Page.TITV,
  });

  return (
    <Track>
      <AppContextProvider
        initialCurrentUser={initialCurrentUser}
        isGdprRequired={isGdprRequired}
        isWebview={isWebview}
        env={env}
      >
        <QueryClientProvider client={queryClient}>
          <EventStreamPlayer
            inProgressStream={inProgressStream}
            mostRecentStream={mostRecentStream}
          />
          <div className="mt-72 px-28">
            <div className="m-auto max-w-container-lg">
              <DailyShowDescription partnerAds={partnerAds} signupNewsletter={signupNewsletter} />
              <PastEvents />
            </div>
          </div>
          {!initialCurrentUser && <NewslettersSignup newsletters={availableNewsletters ?? []} />}
        </QueryClientProvider>
      </AppContextProvider>
    </Track>
  );
};

export default TITV;
